import React from "react";
import axiosInstance from "../../../interceptors";
import { baseUrl } from "../../../config/config";
import StageList from "./StageList";

export default function Offered() {
  return (
    <StageList
      stage="offered"
      title="Offered"
      subtitle="Offers extended — awaiting candidate decision"
      actions={[
        {
          label: "Mark accepted",
          onClick: (c) =>
            axiosInstance.post(`${baseUrl}/job-posting/pipeline/${c.userId}/${c.jobId}/accept`),
        },
        {
          label: "Mark declined",
          danger: true,
          onClick: (c) =>
            axiosInstance.post(`${baseUrl}/job-posting/pipeline/${c.userId}/${c.jobId}/decline`),
        },
      ]}
    />
  );
}
